// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');

// @ actions
const cancelPostPaymentActions = require('actions/cancelPostPayment');
const cardsTransactionsActions = require('actions/getCardsTransactions');

// @ components
const CancelPostPaymentWizard = require('components/myProfile/cancelPostPaymentWizard/cancelPostPaymentWizard');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const CancelPostPaymentErrorStep = require('components/myProfile/cancelPostPaymentErrorStep/cancelPostPaymentErrorStep');
const CancelPostPaymentSuccessStep = require('components/myProfile/cancelPostPaymentSuccessStep/cancelPostPaymentSuccessStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { LoadingSection } = require('commonsComponents/loadingSection');

class CancelPostPaymentView extends React.Component {
    constructor(props) {
        super(props);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { requestCancelPostPayData, match: { params: { cardId } } } = this.props;
        requestCancelPostPayData(cardId);
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }


    isReady() {
        const { immCancelPostPayData } = this.props;
        !immCancelPostPayData.get('isFetching');
    }


    beforeLeaving() {
        const { immCancelPostPayData } = this.props;
        if (immCancelPostPayData.get('submitSuccessful') && immCancelPostPayData.get('willLeave')) {
            this.props.immCancelPostPayData.reset();
        }
    }

    buildError() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <CancelPostPaymentErrorStep
                immCard={immCard}
            />
        );
    }

    buildSuccessful() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <CancelPostPaymentSuccessStep
                immCard={immCard}
            />
        );
    }

    buildWizard() {
        const { match: { params: { cardId, movementId } }, immCards, immTransactions, immCancelPostPayData, setVisibleStep, validateStep, setWillCancel, cancelPostPaymentSuccess } = this.props;
        const confirmationMessage = formatText('cancelPostPayment-redirectConfirmationMessage');
        const confirmationTitle = formatText('cancelPostPayment-redirectConfirmationTitle');
        const acceptText = formatText('cancelPostPayment-redirectConfirmationAcceptButton');
        const cancelText = formatText('cancelPostPayment-redirectConfirmationCancelButton');
        const immCard = immCards.get('byId').get(cardId);
        const immTransaction = immTransactions.getIn([cardId, 'byId', movementId]);
        const postPaymentDetails = immCancelPostPayData.get('postPaymentDetails');

        const {
            bankOperationCode: transactionBankOperationCode,
            basicOperationCode: transactionBasicOperationCode,
            movementNoteDay: transactionMovementNoteDay,
            operationDate: transactionOperationDate,
            dayMovementNumber: transactionDayMovementNumber,
        } = immTransaction.get('extra').toJS();

        const paymentDetail = postPaymentDetails.filter(postPayment => {
            const { fecanota, fecopera, codopbas, codopban, liamovto } = postPayment.toJS();
            return fecanota === transactionMovementNoteDay
                && fecopera === transactionOperationDate
                && codopbas === transactionBasicOperationCode
                && codopban === transactionBankOperationCode
                && liamovto === transactionDayMovementNumber;
        }).first();

        return (
            <div className="row no-outside-gutter">
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                    beforeLeaving={this.beforeLeaving}
                    onConfirmLeave={this.handleConfirmLeave}
                />
                <CancelPostPaymentWizard
                    immCard={immCard}
                    cancelPostPaymentSuccess={cancelPostPaymentSuccess}
                    immCancelPostPayData={immCancelPostPayData}
                    setVisibleStep={setVisibleStep}
                    validateStep={validateStep}
                    cardId={cardId}
                    setWillCancel={setWillCancel}
                    paymentDetail={paymentDetail}
                />
            </div>
        );
    }

    render() {
        let content;
        const { match: { params: { cardId } }, immCards, immCancelPostPayData, immTransactions } = this.props;
        const pageTitle = formatText('cancelPostPayment-pageTitle');
        const dataLoaded = immCancelPostPayData.get('dataLoaded');
        const transactionLoaded = immTransactions.get('dataLoaded')
        const immCard = immCards.get('byId').get(cardId);
        const submitSuccessful = immCancelPostPayData.get('submitSuccessful');
        const errorReceived = immCancelPostPayData.get('error');
        const mappingBreadcrumb = [
            {
                text: pageTitle,
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cancelPostPayment-cancelarAplazamiento'),
                url: ''
            }
        ]

        if (submitSuccessful) {
            content = this.buildSuccessful();
        } else if (errorReceived) {
            content = this.buildError();
        } else if (dataLoaded || transactionLoaded) {
            content = this.buildWizard();
        } else if (immCancelPostPayData.get('isFetching')) {
            content = <LoadingSection />;
        }

        return (
            <section className="cancel-post-payment-view">
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="cancel-post-payment-view__container">
                    <div className="col-xs-12">
                        {content}
                    </div>
                </div>
            </section>
        );
    }
}


CancelPostPaymentView.propTypes = {
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    immCancelPostPayData: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object.isRequired,
    isReady: PropTypes.func,
    requestCardTransactions: PropTypes.func,
    cancelPostPaymentSuccess: PropTypes.func,
    requestCancelPostPayData: PropTypes.func,
    match: PropTypes.object.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    immTransactions: PropTypes.object.isRequired
};

module.exports.constructor = CancelPostPaymentView;
module.exports.CancelPostPaymentView = connect(
    state => ({
        immCancelPostPayData: state.cancelPostPayment,
        immCards: state.cards,
        immCardSecurePayment: state.cardSecurePayment,
        immTransactions: state.cardsTransactions
    }), {
    setVisibleStep: cancelPostPaymentActions.setVisibleStep,
    requestCancelPostPayData: cancelPostPaymentActions.requestCancelPostPayData,
    requestCardTransactions: cardsTransactionsActions.requestCardTransactions,
    validateStep: cancelPostPaymentActions.validateStep,
    cancelPostPaymentSuccess: cancelPostPaymentActions.cancelPostPaymentSuccess,
    setWillCancel: cancelPostPaymentActions.setWillCancel,
    reset: cancelPostPaymentActions.reset,
})(CancelPostPaymentView);
